export enum ContractNumberIncrementType {
    ACCOUNT_WIDE = "account_wide",  // сквозной инкремент по всему аккаунту
    TEMPLATE_BASED = "template_based",  // инкремент в рамках шаблона
    MANUAL = "manual"  // без инкремента
} 